import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import { Button } from "components";
import { useTranslate } from "hooks";
import { WizardTitleButtons } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardTitleButtons";
import {
  useCurrentQuestionnaire,
  useIsFetching,
  useMaximumQuestionnairesCount,
  useQuestionnaireLists,
  useWizardActions,
} from "stores/wizardStore";
import { WizardLeftSidebarZonesMenu } from "./WizardLeftSidebarZonesMenu";
import s from "./WizardLeftSidebarExtension.module.scss";

export const WizardLeftSidebarZoneProperties = Scrivito.connect(() => {
  const translate = useTranslate();
  const currentQuestionnaire = useCurrentQuestionnaire();
  const isSomethingFetching = useIsFetching();
  const questionnaireLists = useQuestionnaireLists();
  const maxQuestionnaireCount = useMaximumQuestionnairesCount();
  const { createWizardStepQuestionnaire } = useWizardActions();

  const createEventItem = useCallback(() => {
    createWizardStepQuestionnaire();
  }, [createWizardStepQuestionnaire]);

  const isUnderLimit = questionnaireLists.length < maxQuestionnaireCount;

  return (
    <>
      <WizardTitleButtons isSidebar />
      <WizardLeftSidebarZonesMenu
        questionnaireLists={questionnaireLists}
        currentQuestionnaireIdentifier={currentQuestionnaire?.id}
      />
      <div className="d-flex justify-content-between mt-2">
        <div className="text-gray-500">
          {isUnderLimit
            ? translate("WIZARD_NUMBER_OF_ZONES_WITH_VALUES", [
                questionnaireLists.length ?? 0,
                maxQuestionnaireCount,
              ])
            : translate("WIZARD_NUMBER_OF_ZONES_LIMIT_WITH_VALUE", [
                maxQuestionnaireCount,
              ])}
        </div>
        <Button
          data-testid="WizardLeftSidebarZoneProperties_add-zone-btn"
          color="secondary"
          icon="plus-regular"
          disabled={!isUnderLimit || isSomethingFetching}
          isLoading={isSomethingFetching}
          onClick={createEventItem}
          className={cx(
            "text-white px-2 height-4 d-flex align-items-center",
            s.zonesMenuButton,
          )}
        >
          {translate("WIZARD_ADD_ZONE")}
        </Button>
      </div>
    </>
  );
});
